import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["menu", "button", "menuItem"];
  static values = { open: Boolean, default: false };

  declare readonly buttonTarget: HTMLElement;
  declare readonly menuTarget: HTMLElement;
  declare readonly menuItemTargets: HTMLElement[];
  declare readonly hasButtonTarget: boolean;
  declare readonly hasMenuItemTarget: boolean;
  declare openValue: boolean;

  connect() {
    if (this.menuTarget) {
      const uniqueId = this.uniqueId();
      this.buttonTarget.setAttribute("aria-haspopup", "true");
      this.buttonTarget.setAttribute("aria-controls", uniqueId);
      this.menuTarget.setAttribute("id", uniqueId);
    }
  }

  disconnect() {
    if (this.menuTarget) {
      this.buttonTarget.removeAttribute("aria-haspopup");
    }
  }

  openValueChanged() {
    if (this.openValue === true) {
      this.buttonTarget.setAttribute("aria-expanded", "true");
      this.menuTarget.removeAttribute("hidden");
    } else {
      this.buttonTarget.setAttribute("aria-expanded", "false");
      this.menuTarget.setAttribute("hidden", "true");
    }

    if (this.openValue === true && this.hasMenuItemTarget) {
      this.menuItemTargets[0].focus();
    }
  }

  show() {
    this.openValue = true;
  }

  hide(event: any) {
    if (event.target.classList.contains("fui-dropdown-menu-item")) {
      this.openValue = false;
    }
    if (
      event.target.nodeType &&
      this.element.contains(event.target) === false &&
      this.openValue
    ) {
      this.openValue = false;
    }
  }

  toggle() {
    this.openValue = !this.openValue;
  }

  nextItem() {
    const nextIndex = Math.min(
      this.currentItemIndex + 1,
      this.menuItemTargets.length - 1,
    );
    this.menuItemTargets[nextIndex].focus();
  }

  previousItem() {
    const previousIndex = Math.max(this.currentItemIndex - 1, 0);
    this.menuItemTargets[previousIndex].focus();
  }

  uniqueId() {
    return `dropdown-${Math.floor(Math.random() * Date.now())}`;
  }

  get currentItemIndex() {
    return this.menuItemTargets.indexOf(document.activeElement);
  }
}
